import { render, staticRenderFns } from "./ChatPump.vue?vue&type=template&id=0d51529a"
import script from "./ChatPump.vue?vue&type=script&lang=js"
export * from "./ChatPump.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports